export default {
  getHomeMenuItems: (state) => state.appMenuItems?.filter((item) => item.appMenuType === 'Home') ?? [],
  getFinanceMenuItems: (state) => state.appMenuItems?.filter((item) => item.appMenuType === 'Finance') ?? [],
};
